<div class="flex flex-column h-full">
  <form [formGroup]="formGroup" class="flex flex-column gap-4 mb-4">
    <div class="flex flex-column gap-2">
      <label for="firstname" class="font-medium">Prénom <span class="text-red-500">*</span></label>
      <input pInputText id="firstname" aria-describedby="firstname-help" formControlName="firstname"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('firstname')}" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('firstname')" id="firstname-help" class="text-gray-600">
        Renseigner ici le prénom de l'utilisateur (2-50 caractères).
      </small>
      <small *ngIf="hasFieldError('firstname')" class="text-red-500">
        {{ getFieldError('firstname') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="lastname" class="font-medium">Nom <span class="text-red-500">*</span></label>
      <input pInputText id="lastname" aria-describedby="lastname-help" formControlName="lastname"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('lastname')}" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('lastname')" id="lastname-help" class="text-gray-600">
        Renseigner ici le nom de l'utilisateur (2-50 caractères).
      </small>
      <small *ngIf="hasFieldError('lastname')" class="text-red-500">
        {{ getFieldError('lastname') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="username" class="font-medium">Nom d'utilisateur <span class="text-red-500">*</span></label>
      <input pInputText id="username" aria-describedby="username-help" formControlName="username"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('username')}" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('username')" id="username-help" class="text-gray-600">
        Renseigner ici le nom d'utilisateur (3-30 caractères).
      </small>
      <small *ngIf="hasFieldError('username')" class="text-red-500">
        {{ getFieldError('username') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="email" class="font-medium">Email <span class="text-red-500">*</span></label>
      <input pInputText id="email" aria-describedby="email-help" formControlName="email" type="email"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('email')}" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('email')" id="email-help" class="text-gray-600">
        Renseigner ici l'adresse email de l'utilisateur.
      </small>
      <small *ngIf="hasFieldError('email')" class="text-red-500">
        {{ getFieldError('email') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="phoneNumber" class="font-medium">Téléphone <span class="text-red-500">*</span></label>
      <input pInputText id="phoneNumber" aria-describedby="phone-help" formControlName="phoneNumber" type="tel"
             [ngClass]="{'ng-invalid ng-dirty': hasFieldError('phoneNumber')}" />
      <small *ngIf="boundData?.isCreate && !hasFieldError('phoneNumber')" id="phone-help" class="text-gray-600">
        Ex: +221 33 860 00 00
      </small>
      <small *ngIf="hasFieldError('phoneNumber')" class="text-red-500">
        {{ getFieldError('phoneNumber') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="institution" class="font-medium">Institution <span class="text-red-500">*</span></label>
      <p-select (onChange)="loadGroups($event)" [disabled]="!!boundData?.isView" id="institution"
                  aria-describedby="institution-help" formControlName="institution"
                  [options]="institutions" optionLabel="name" optionValue="id"
                  [ngClass]="{'ng-invalid ng-dirty': hasFieldError('institution')}"
                  placeholder="Sélectionner une institution"></p-select>
      <small *ngIf="boundData?.isCreate && !hasFieldError('institution')" id="institution-help" class="text-gray-600">
        Sélectionner l'institution de l'utilisateur.
      </small>
      <small *ngIf="hasFieldError('institution')" class="text-red-500">
        {{ getFieldError('institution') }}
      </small>
    </div>
    <div class="flex flex-column gap-2">
      <label for="group" class="font-medium">Groupe <span class="text-red-500">*</span></label>
      <p-select [disabled]="!!boundData?.isView" id="group" optionValue="id" aria-describedby="group-help"
                  formControlName="group" [options]="groups" optionLabel="name"
                  [ngClass]="{'ng-invalid ng-dirty': hasFieldError('group')}"
                  placeholder="Sélectionner un groupe"></p-select>
      <small *ngIf="boundData?.isCreate && !hasFieldError('group')" id="group-help" class="text-gray-600">
        Sélectionner le groupe de l'utilisateur.
      </small>
      <small *ngIf="hasFieldError('group')" class="text-red-500">
        {{ getFieldError('group') }}
      </small>
    </div>
  </form>
  <div class="flex flex-grow-1 gap-2 align-items-end justify-content-end">
    <p-button *ngIf="!boundData?.isCreate" pRipple [severity]="boundData?.data.enabled ? 'danger' : 'success'"
              [label]="boundData?.data.enabled ? 'Désactiver' : 'Activer'"
              (onClick)="toggleUser()"></p-button>
    <p-button pRipple *ngIf="!formGroup.disabled" [style]="{width: '100%'}"
              [label]=" boundData?.isCreate  ? 'Enregistrer' : 'Modifier'" [disabled]="!formGroup.valid"
              [loading]="isLoading" (onClick)="boundData?.isCreate ? create() : update()"></p-button>
  </div>
</div>
